"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  size_limit: 'max_upload_size',
  filetype: 'not_supported_file'
};
exports["default"] = _default;